import { useQueries, useQuery } from "@tanstack/react-query";
import api from "api";


export const query = {
	top: {
		day: { queryKey: ["top-day"], queryFn: () => api.content.top({ days: 1, date: new Date().toISOString() }) },
		week: { queryKey: ["top-week"], queryFn: () => api.content.top({ days: 8, date: new Date().toISOString() }) },
		featured: { queryKey: ["top-featured"], queryFn: api.content.featured }
	}
};

export const useQueriesTop = () => useQueries({ queries: [query.top.day, query.top.week] });

export const useQueryFeatured = () => useQuery(query.top.featured);

export const useQueryLastSeen = () => useQuery({
	queryKey: ["last-seen"],
	queryFn: api.content.last
});

export const useQueryCampaigns = () => useQuery({
	queryKey: ["campaigns"],
	queryFn: api.campaign.getAll
});